module.exports = __webpack_public_path__ + "d7d5c2b3ee9221de71355d49fcf98b62.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-29.png
// module id = 2171
// module chunks = 0